import { useEffect } from "react";
import React from "react";
import { Form, Input, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const JourneyForm = ({ initialValues = {}, onSubmit, editMode = false }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        image: initialValues?.image
          ? [
              {
                uid: "-1",
                name: initialValues.image,
                status: "done",
                url: `${process.env.REACT_APP_API_BASE_URL}/uploads/${initialValues.image}`,
              },
            ]
          : [],
      });
    }
  }, [initialValues, form]);

  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList || [];
  };

  const handleFinish = (values) => {
    const formData = new FormData();

    formData.append("year", values.year);
    formData.append("title_id", values.title_id);
    formData.append("title_en", values.title_en);
    formData.append("description_id", values.description_id);
    formData.append("description_en", values.description_en);

    if (values.image && values.image.length > 0) {
      const file = values.image[0];

      if (file.originFileObj) {
        formData.append("image", file.originFileObj);
      }
    }

    onSubmit(formData);
    form.resetFields();
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      <Form.Item
        name="year"
        label="Year"
        rules={[{ required: true, message: "'year' is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="title_id"
        label="Title ID"
        rules={[{ required: true, message: "'title_id' is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="title_en"
        label="Title EN"
        rules={[{ required: true, message: "'title_en' is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="description_id"
        label="Description_ID"
        rules={[{ required: true, message: "'description_id' is required" }]}
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item
        name="description_en"
        label="Description_EN"
        rules={[{ required: true, message: "'description_en' is required" }]}
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item
        name="image"
        label="Image"
        valuePropName="fileList"
        getValueFromEvent={normFile}
      >
        <Upload beforeUpload={() => false} maxCount={1} listType="picture">
          <Button icon={<UploadOutlined />}>Upload Image</Button>
        </Upload>
      </Form.Item>

      <Form.Item style={{ textAlign: "right" }}>
        <Button
          style={{
            backgroundColor: "#ec4899",
            borderColor: "#ec4899",
            color: "#fff",
          }}
          htmlType="submit"
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default JourneyForm;
